/* ==========================================================================
   AURRA — size guide tabs

   The tab you press already carries the other dialog's trigger attribute, so
   that dialog's own delegated handler opens it with its own tracking. All
   this file does is close the panel being left.

   It must run LAST of the three delegated click handlers, which it does: the
   two dialogs register theirs from inline scripts during parse, this one is
   deferred. So the class removal here is never undone by the opener.
   ========================================================================== */
(function () {
  'use strict';

  try {
    document.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-aurra-sg-tab]');
      if (!tab) return;

      /* Leaving the panel that is NOT the one being asked for. */
      var leaving = tab.getAttribute('data-aurra-sg-tab') === 'chart' ? 'sa' : 'szc';

      ['modal', 'overlay'].forEach(function (part) {
        var el = document.querySelector('[data-aurra-' + leaving + '-' + part + ']');
        if (el) el.classList.remove('is-open');
      });

      /* Still inside a dialog — the closing panel's own close() would have
         released the scroll lock, so take it back. */
      document.body.style.overflow = 'hidden';
    });
  } catch (err) {
    if (window.console && console.warn) console.warn('[aurra-size-guide-tabs]', err);
  }
})();
